import { ApiRequest } from "../../Handlers/ApiReqest";
import { InterActive } from "../../utilities/ViewModelStructure";

export class MarketersListVM extends InterActive{
    private marketersList:{id:string , name:string , commission:string , trainees_count:string, status:'active'|'inActive'}[] = []

    public get List():{id:string , name:string , commission:string , trainees_count:string, status:'active'|'inActive'}[] { return this.marketersList }

    
    private _status : 'active'|'inActive' = 'active';
    public get status() : 'active'|'inActive' {
        return this._status;
    }
    public set status(v : 'active'|'inActive') {
        this._status = v;
        this.update()
    }
    

    public load(search?:string){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.marketersPriefList(this._status,search)
                    if(response){
                        if(response.status){
                            if(response.data.status){
                                this.marketersList = response.data.data
                                this.Messege = ''
                                this.update()
                            }else {
                                this.marketersList = []
                                this.Messege = response.data.messege
                                this.update()
                            }
                        }else {
                            this.marketersList = []
                            this.Messege = 'حدثت مشكلة فى الاتصال بالانترنت'
                            this.update()
                        }
                    }
                }catch{
                    this.marketersList = []
                    this.Messege = 'حدثت مشكلة فى الاتصال بالانترنت'
                    this.update()
                }
            }
        )
    }

}